import React, { useState } from "react";
import { StyleSheet, View, Platform } from "react-native";

import { buttonStyle } from "../../common/ActionsMenuButton/utils";
import ActionButton from "../../common/ActionsMenuButton/ActionButton";

import QuestionIcon from "../../common/ActionsMenuButton/icons/QuestionIcon";
import TagsIcon from "../../common/ActionsMenuButton/icons/TagsIcon";
import ActivityIcon from "../../common/ActionsMenuButton/icons/ActivityIcon";
import AppTheme from "../../AppTheme";

export default function TagsMenuButton({ addTag, toggleCopyTagsPanel }) {
  const [actionButton, setActionButton] = useState(null);
  return (
    <View
      style={buttonStyle}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      <ActionButton
        ref={(r) => setActionButton(r)}
        buttonColor={AppTheme.DEFAULT_COLOR}
        zIndex={999}
        source={"TagsMenuButton"}
        buttonTextStyle={styles.mainButton}
      >
        <ActionButton.Item
          underline
          buttonColor="#FFF"
          title="How to use tags"
          onPress={() => {}}
        >
          <QuestionIcon style={styles.actionButtonIcon} />
        </ActionButton.Item>

        <ActionButton.Item
          buttonColor="#FFF"
          title="Copy tags from activity"
          onPress={toggleCopyTagsPanel}
        >
          <ActivityIcon style={styles.actionButtonIcon} />
        </ActionButton.Item>

        <ActionButton.Item buttonColor="#FFF" title="New Tag" onPress={addTag}>
          <TagsIcon style={styles.actionButtonIcon} />
        </ActionButton.Item>
      </ActionButton>
    </View>
  );
}

const styles = StyleSheet.create({
  mainButton: {
    fontSize: 44,
    height: 58,
    marginTop: -5,
    fontWeight: "200",
    fontFamily:  Platform.select({ default: "Nunito", android: "Nunito-Regular" }),
  },
  actionButtonIcon: {
    height: 23,
    width: 23,
  },
});
